import { useEffect, useState } from "react";

const MINUTE_MS = 60 * 1000;

/** The time, a minute at a time, so `Today` and `Yesterday` turn over at midnight. */
export const useMinute = (): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), MINUTE_MS);
    return () => window.clearInterval(timer);
  }, []);
  return now;
};
